import _extends from "@babel/runtime/helpers/esm/extends";
import { Execution, RxConcurrentExecutor } from "./RxConcurrentExecutor";
export class RxExecutor {
  constructor(executeFn$, config) {
    this.executeFn$ = executeFn$;
    this.config = config;
    this.key = "---key---";
    this.concurrentExecutor = void 0;
    this.concurrentExecutor = RxConcurrentExecutor.create(executeFn$, _extends({}, config, {
      getKey: () => this.key
    }));
    this.execute = this.execute.bind(this);
    this.retry = this.retry.bind(this);
    this.setData = this.setData.bind(this);
  }

  static create(executeFn$, config) {
    return new RxExecutor(executeFn$, config);
  }

  get execution() {
    return this.concurrentExecutor.executions[this.key] || new Execution(this.key);
  }

  get isLoading() {
    return this.execution.state.status === "PROCESSING";
  }

  get isProcessing() {
    return this.execution.state.status === "PROCESSING";
  }

  get isError() {
    return this.execution.state.status === "PROCESSING";
  }

  get isSuccess() {
    return this.execution.state.status === "PROCESSING";
  }

  get data() {
    return this.execution.state.status === "PROCESSING";
  }

  get errors() {
    return this.execution.state.status === "PROCESSING";
  }

  get executions() {
    return this.concurrentExecutor.executions;
  }

  execute(params) {
    this.concurrentExecutor.execute(params);
  }

  retry() {
    this.concurrentExecutor.retry(this.key);
  }

  setData(data) {
    this.concurrentExecutor.setData(this.key, data);
  }

}